import { THttpService } from '@/services/HttpService';

import { getValue } from '@/helpers/GetValueHelper';

import { TResponseTerms } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formatSuccess = (data: any) => {
  return {
    title: getValue(
      data,
      'items[0].contentFields[0].contentFieldValue.data',
      '',
    ),
    content: getValue(
      data,
      'items[0].contentFields[1].contentFieldValue.data',
      '',
    ),
  };
};

const formatError = () => {
  return {
    title: 'Ops...',
    content: '<p>Desculpe, não conseguimos encontrar o conteúdo.</p>',
  };
};

export const getTerms = async (
  api: THttpService,
  key: string,
): Promise<TResponseTerms | undefined> => {
  const query = encodeURI(`filter=(title+eq+'${key}')`);
  const path =
    '/o/headless-delivery/v1.0/sites/20124/structured-contents?flatten=true&';

  let data = {};
  try {
    const response = await api.get(path + query);
    data = response.data;
    return formatSuccess(data);
  } catch (error) {
    return formatError();
  }
};
